/** ***** reducers ***** */

// activityCards reducer
export const REMOVE_LOCAL_NEW_INDICATOR = 'REMOVE_LOCAL_NEW_INDICATOR';
export const SET_ACTIVITY_CARD_DETAILS = 'SET_ACTIVITY_CARD_DETAILS';

// activityDateRange reducer
export const SET_ACTIVITY_DATE_RANGE_DETAILS = 'SET_ACTIVITY_DATE_RANGE_DETAILS';
export const SET_RANGE_START_AND_RANGE_END = 'SET_RANGE_START_AND_RANGE_END';

// activityList reducer
export const SET_ACTIVITY_LIST_DETAILS = 'SET_ACTIVITY_LIST_DETAILS';

// chips reducer
export const CHIP_SELECTED = 'CHIP_SELECTED';
export const DEFAULT_CHIP_SELECTED = 'DEFAULT_CHIP_SELECTED';

// dashboardView reducer
export const TOGGLE_CALENDAR_VIEW = 'TOGGLE_CALENDAR_VIEW';
export const TOGGLE_LIST_VIEW = 'TOGGLE_LIST_VIEW';

// domain reducer
export const SET_DOMAIN = 'SET_DOMAIN';

// dropdownOptions reducer
export const SET_DROPDOWN_OPTIONS = 'SET_DROPDOWN_OPTIONS';
export const UPDATE_DROPDOWN_OPTIONS = 'UPDATE_DROPDOWN_OPTIONS';
export const SET_DROPDOWN_ADDITIONAL_FILTERS = 'SET_DROPDOWN_ADDITIONAL_FILTERS';
export const DROP_DROPDOWN_ADDITIONAL_FILTERS = 'DROP_DROPDOWN_ADDITIONAL_FILTERS';
export const CLEAR_DROPDOWN_ADDITIONAL_FILTERS = 'CLEAR_DROPDOWN_ADDITIONAL_FILTERS';
export const SET_DROPDOWN_SEARCH = 'SET_DROPDOWN_SEARCH';
export const RESET_DROPDOWN_SEARCH = 'RESET_DROPDOWN_SEARCH';
export const SET_DROPDOWN_KEY_FILTERS = 'SET_DROPDOWN_KEY_FILTERS';
export const UPDATE_DROPDOWN_KEY_FILTERS = 'UPDATE_DROPDOWN_KEY_FILTERS';
export const RESET_DROPDOWN_KEY_FILTERS = 'RESET_DROPDOWN_KEY_FILTERS';
export const SET_DROPDOWN_KEY_SEARCH = 'SET_DROPDOWN_KEY_SEARCH';
export const SET_DROPDOWN_FILTER_DATA = 'SET_DROPDOWN_FILTER_DATA';
export const UPDATE_DROPDOWN_FILTER_DATA = 'UPDATE_DROPDOWN_FILTER_DATA';
export const SET_COLUMN_DROPDOWN_FILTERS = 'SET_COLUMN_DROPDOWN_FILTERS';
export const SET_COLUMN_DROPDOWN_SEARCH = 'SET_COLUMN_DROPDOWN_SEARCH';
export const UPDATE_COLUMN_DROPDOWN_FILTERS = 'UPDATE_COLUMN_DROPDOWN_FILTERS';
export const UPDATE_DROPDOWN_OPTIONS_COUNT_BY_KEY = 'UPDATE_DROPDOWN_OPTIONS_COUNT_BY_KEY';
export const UPDATE_DROPDOWN_OPTIONS_WITH_FILTERS = 'UPDATE_DROPDOWN_OPTIONS_WITH_FILTERS';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const LOAD_DROPDOWN_OPTIONS = 'LOAD_DROPDOWN_OPTIONS';
export const UPDATE_NESTED_DROPDOWN_OPTIONS_COUNT_BY_KEY = 'UPDATE_NESTED_DROPDOWN_OPTIONS_COUNT_BY_KEY';
export const SET_NESTED_DROPDOWN_SEARCH = 'SET_NESTED_DROPDOWN_SEARCH';
export const CLEAR_DROPDOWNS = 'CLEAR_DROPDOWNS';
export const ADD_DROPDOWN_OPTIONS = 'ADD_DROPDOWN_OPTIONS';
export const SET_DROPDOWN_DISPLAY_NAMES = 'SET_DROPDOWN_DISPLAY_NAMES';
export const UPDATE_ALL_DROPDOWN_OPTIONS_AFTER_FILTER = 'UPDATE_ALL_DROPDOWN_OPTIONS_AFTER_FILTER';
export const CLEAR_DROPDOWN_SEARCH = 'CLEAR_DROPDOWN_SEARCH';

// dropdown options v2 reducer
export const CREATE_DROPDOWN_FILTER = 'CREATE_DROPDOWN_FILTER';
export const REMOVE_DROPDOWN_FILTER = 'REMOVE_DROPDOWN_FILTER';
export const SELECT_DROPDOWN_FILTER_VALUE = 'SELECT_DROPDOWN_FILTER_VALUE';
export const SELECT_SINGLE_DROPDOWN_FILTER_VALUE = 'SELECT_SINGLE_DROPDOWN_FILTER_VALUE';
export const SELECT_ALL_DROPDOWN_VALUES = 'SELECT_ALL_DROPDOWN_VALUES';
export const SET_ALL_DROPDOWN_VALUES_TRUE = 'SET_ALL_DROPDOWN_VALUES_TRUE';
export const SET_ALL_DROPDOWN_VALUES_FALSE = 'SET_ALL_DROPDOWN_VALUES_FALSE';
export const SET_DROPDOWN_FILTER_OPTIONS = 'SET_DROPDOWN_FILTER_OPTIONS';
export const REPLACE_DROPDOWN_FILTER_OPTIONS = 'REPLACE_DROPDOWN_FILTER_OPTIONS';
export const SET_DROPDOWN_FILTER_SEARCH_FILTER = 'SET_DROPDOWN_FILTER_SEARCH_FILTER';
export const SET_DROPDOWN_DATE_FILTER_SELECTION = 'SET_DROPDOWN_DATE_FILTER_SELECTION';

// dropdown options v2 saga
export const CLEAR_MORE_DROPDOWN_FILTERS = 'CLEAR_MORE_DROPDOWN_FILTERS';

// ag-grid column options actions
export const SET_MODAL_COLUMN_DROPDOWN_SEARCH = 'SET_MODAL_COLUMN_DROPDOWN_SEARCH';
export const SET_MODAL_COLUMN_DROPDOWN_FILTERS = 'SET_MODAL_COLUMN_DROPDOWN_FILTERS';
export const UPDATE_MODAL_COLUMN_DROPDOWN_FILTERS = 'UPDATE_MODAL_COLUMN_DROPDOWN_FILTERS';

// executionDashboardPreferences reducer
export const SET_EXECUTION_DASHBOARD_PREFERENCES = 'SET_EXECUTION_DASHBOARD_PREFERENCES';

// listViewDate reducer
export const SET_LIST_VIEW_DATE = 'SET_LIST_VIEW_DATE';

// modal reducer
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const SET_ACTIVE_CARD_POSITION = 'SET_ACTIVE_CARD_POSITION';
export const SET_OUTER_MODAL_ELEMENT = 'SET_OUTER_MODAL_ELEMENT';
export const TOGGLE_ACTIVITY_DETAIL = 'TOGGLE_ACTIVITY_DETAIL';
export const TOGGLE_EMPLOYEE_DETAIL = 'TOGGLE_EMPLOYEE_DETAIL';

// newTaskToasts reducer
export const HIDE_TOAST = 'HIDE_TOAST';
export const SET_CURRENT_WEEK_NEW_TASK_TOASTS = 'SET_CURRENT_WEEK_NEW_TASK_TOASTS';
export const SET_CURRENT_WEEK_SINGLE_TOAST_DETAILS = 'SET_CURRENT_WEEK_SINGLE_TOAST_DETAILS';

// quickFilter reducer
export const SET_QUICK_FILTER_TEXT = 'SET_QUICK_FILTER_TEXT';

// reps reducer
export const CLOSE_REP_MODAL = 'CLOSE_REP_MODAL';
export const TOGGLE_REP_MODAL = 'TOGGLE_REP_MODAL';
export const TOGGLE_VIEW_MANAGEMENT = 'TOGGLE_VIEW_MANAGEMENT';

// searchFilter reducer
export const CLEAR_SEARCH_FILTER_TEXT = 'CLEAR_SEARCH_FILTER_TEXT';
export const SET_SEARCH_FILTER_TEXT = 'SET_SEARCH_FILTER_TEXT';

// searchToggle reducer
export const CLOSE_SEARCH_INPUT = 'CLOSE_SEARCH_INPUT';
export const SEARCH_INPUT_FOCUSED = 'SEARCH_INPUT_FOCUSED';

// selectedStore reducer
export const SERVER_LOAD_SUCCESS = 'SERVER_LOAD_SUCCESS';
export const SET_CALENDAR_VIEW_SELECTED_STORE = 'SET_CALENDAR_VIEW_SELECTED_STORE';
export const SET_CALENDAR_VIEW_SELECTED_STORE_DETAILS = 'SET_CALENDAR_VIEW_SELECTED_STORE_DETAILS';
export const SET_LIST_VIEW_SELECTED_STORE = 'SET_LIST_VIEW_SELECTED_STORE';
export const SET_LIST_VIEW_SELECTED_STORE_DETAILS = 'SET_LIST_VIEW_SELECTED_STORE_DETAILS';

/** ***** saga triggers ***** */

// loadExecutionDashboard saga
export const LOAD_EXECUTION_DASHBOARD = 'LOAD_EXECUTION_DASHBOARD';

// requestRepDetails saga
export const REQUEST_REP_DETAILS = 'REQUEST_REP_DETAILS';

// requestStoreNumberDropdownOptions saga
export const REQUEST_STORE_NUMBER_DROPDOWN_OPTIONS = 'REQUEST_STORE_NUMBER_DROPDOWN_OPTIONS';

// setCalendarViewSelectedStoreAndGrabData saga
export const SET_CALENDAR_VIEW_SELECTED_STORE_AND_GRAB_DATA = 'SET_CALENDAR_VIEW_SELECTED_STORE_AND_GRAB_DATA';

// setListViewSelectedStoreAndGrabData saga
export const SET_LIST_VIEW_SELECTED_STORE_AND_GRAB_DATA = 'SET_LIST_VIEW_SELECTED_STORE_AND_GRAB_DATA';

// requestRepActivityCardData saga
export const FETCH_ACTIVITY_CARD_DETAILS = 'FETCH_ACTIVITY_CARD_DETAILS';

// removeActivityCardNewIndicator saga
export const REMOVE_NEW_INDICATOR = 'REMOVE_NEW_INDICATOR';

// updateActivityDateRange saga
export const RECALCULATE_START_AND_END_DATES = 'RECALCULATE_START_AND_END_DATES';

// recalculateStartAndEndDatesAndTriggerModal saga
export const RECALCULATE_DATES_AND_TRIGGER_MODAL = 'RECALCULATE_DATES_AND_TRIGGER_MODAL';

// requestRepActivityListData saga
export const FETCH_ACTIVITY_LIST_DETAILS = 'FETCH_ACTIVITY_LIST_DETAILS';

// recalculateListViewDate saga
export const RECALCULATE_LIST_VIEW_DATE = 'RECALCULATE_LIST_VIEW_DATE';

// requestExecutionDashboardPreferences saga
export const FETCH_EXECUTION_DASHBOARD_PREFERENCES = 'FETCH_EXECUTION_DASHBOARD_PREFERENCES';

export const FETCH_USER_LOCALE = 'FETCH_USER_LOCALE';

// checkbox actionTypes
export const SET_CHECKBOX_SELECTION = 'SET_CHECKBOX_SELECTION';

// modal dialog actionTypes
export const OPEN_MODAL_DIALOG = 'OPEN_MODAL_DIALOG';
export const CLOSE_MODAL_DIALOG = 'CLOSE_MODAL_DIALOG';

// export & import actionTypes
export const SET_EXPORT_SELECTION = 'SET_EXPORT_SELECTION';
export const FILE_EXPORT_DATA = 'FILE_EXPORT_DATA';
export const SET_IMPORT_SELECTION = 'SET_IMPORT_SELECTION';
export const SET_IMPORT_FILE = 'SET_IMPORT_FILE';
export const SET_IMPORT_PROGRESS_START = 'SET_IMPORT_PROGRESS_START';
export const SET_IMPORT_PROGRESS_DONE = 'SET_IMPORT_PROGRESS_DONE';
export const SET_IMPORT_ERROR_MESSAGE = 'SET_IMPORT_ERROR_MESSAGE';
export const CLEAR_IMPORT_ERROR_MESSAGE = 'CLEAR_IMPORT_ERROR_MESSAGE';
export const SET_IMPORT_WARNING_MESSAGE = 'SET_IMPORT_WARNING_MESSAGE';
export const CLEAR_IMPORT_WARNING_MESSAGE = 'CLEAR_IMPORT_WARNING_MESSAGE';
export const FILE_IMPORT_DATA = 'FILE_IMPORT_DATA';

// notification actionTypes
export const SET_NOTIFICATION_SNACKBAR = 'SET_NOTIFICATION_SNACKBAR';
export const CLEAR_NOTIFICATION_SNACKBAR = 'CLEAR_NOTIFICATION_SNACKBAR';
export const UPDATE_GRID_RENDER_WAIT_STATUS = 'UPDATE_GRID_RENDER_WAIT_STATUS';
export const UPDATE_AG_GRID_PAGE_NUMBER = 'UPDATE_AG_GRID_PAGE_NUMBER';

// sideNavItems reducer
export const SET_SIDE_NAV_ACTIVE_ITEM = 'SET_SIDE_NAV_ACTIVE_ITEM';

// contacts reducer
export const UPDATE_USERS = 'UPDATE_USERS';
export const UPDATE_CONTACT_SEARCH_TEXT = 'UPDATE_CONTACT_SEARCH_TEXT';
export const ADD_CONTACT_USERS = 'ADD_CONTACT_USERS';
export const RESET_CONTACTS = 'RESET_CONTACTS';
export const FIND_CONTACTS = 'FIND_CONTACTS';
export const NEW_THREADS_USERS = 'NEW_THREADS_USERS';

// image uploader
export const IMAGE_FILE_DETAILS = 'IMAGE_FILE_DETAILS';
export const IMAGE_FILE_RESET = 'IMAGE_FILE_RESET';
export const SET_IMAGE_FILE = 'SET_IMAGE_FILE';
export const POST_IMAGE_FILE = 'POST_IMAGE_FILE';
export const CLEAR_IMAGE_FILE = 'CLEAR_IMAGE_FILE';
export const SET_IMAGE_ERROR = 'SET_IMAGE_ERROR';

// list view inline editing
export const LIST_VIEW_EDIT_UPDATE = 'LIST_VIEW_EDIT_UPDATE';
export const LIST_VIEW_UPDATE_CANCEL = 'LIST_VIEW_UPDATE_CANCEL';
export const LIST_VIEW_UPDATE_COMPLETE = 'LIST_VIEW_UPDATE_COMPLETE';

// person card
export const SET_REP_PHOTO = 'SET_REP_PHOTO';
export const SET_REP_PHOTO_FAILURE = 'SET_REP_PHOTO_FAILURE';
export const SET_REP_PHOTO_SUCCESS = 'SET_REP_PHOTO_SUCCESS';

// userInfo saga
export const FETCH_USER_INFO = 'FETCH_USER_INFO';

// userInfo reducer
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';
export const SET_USER_TS = 'SET_USER_TS';

// sync messages
export const CREATE_MESSAGE_THREADS = 'CREATE_MESSAGE_THREADS';
export const POLL_SYNC_THREADS = 'POLL_SYNC_THREADS';
export const SYNC_ACTIVE_USERS = 'SYNC_ACTIVE_USERS';
export const SYNC_CONTACT_USERS = 'SYNC_CONTACT_USERS';
export const SYNC_INACTIVE_USERS = 'SYNC_INACTIVE_USERS';
export const SYNC_MESSAGES = 'SYNC_MESSAGES';
export const SYNC_MESSAGE_THREADS_CALL = 'SYNC_MESSAGE_THREADS_CALL';
export const UPDATE_MESSAGE_THREADS = 'UPDATE_MESSAGE_THREADS';
export const SET_SELECTED_THREAD_ID = 'SET_SELECTED_THREAD_ID';
export const UPDATE_MESSAGE_DATA_IN_THREADS = 'UPDATE_MESSAGE_DATA_IN_THREADS';

// retailers
export const GET_RETAILERS = 'GET_RETAILERS';
export const SET_RETAILERS = 'SET_RETAILERS';

// Roles drop down action types
export const ADD_ROLES = 'ADD_ROLES';
export const GET_ROLES = 'GET_ROLES';
export const SELECTED_ROLE = 'SELECTED_ROLE';
export const SEARCH_ROLE_VALUE = 'SEARCH_ROLE_VALUE';
export const CLEAR_SEARCH_ROLES = 'CLEAR_SEARCH_ROLES';
export const SELECT_ALL_ROLE_OPTIONS = 'SELECT_ALL_ROLE_OPTIONS';
export const DESELECT_ALL_ROLE_OPTIONS = 'DESELECT_ALL_ROLE_OPTIONS';

export const ADD_NEW_ANNOUNCEMENTS = 'ADD_NEW_ANNOUNCEMENTS';
export const ADD_DRAFT_ANNOUNCEMENTS = 'ADD_DRAFT_ANNOUNCEMENTS';
export const SYNC_ANNOUNCEMENTS = 'SYNC_ANNOUNCEMENTS';
export const SYNC_DRAFT_ANNOUNCEMENTS = 'SYNC_DRAFT_ANNOUNCEMENTS';
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT';
export const LOADING_TOGGLE = 'LOADING_TOGGLE';
export const GET_ANNOUNCEMENT_STATS = 'GET_ANNOUNCEMENT_STATS';

// error status
export const SHOW_ERROR_STATUS = 'SHOW_ERROR_STATUS';
export const HIDE_ERROR_STATUS = 'HIDE_ERROR_STATUS';

export const SET_IMPORT_LOADING_BAR_DATA = 'SET_IMPORT_LOADING_BAR_DATA';
export const CLEAR_IMPORT_LOADING_BAR_DATA = 'CLEAR_IMPORT_LOADING_BAR_DATA';

// cache
export const SET_MESSAGE_CACHE = 'SET_MESSAGE_CACHE';
export const GET_MESSAGE_CACHE = 'GET_MESSAGE_CACHE';
export const SET_CONTACT_CACHE = 'SET_CONTACT_CACHE';
export const GET_CONTACT_CACHE = 'GET_CONTACT_CACHE';
export const SET_LAST_ACTIVE_CACHE = 'SET_LAST_ACTIVE_CACHE';
export const GET_LAST_ACTIVE_CACHE = 'GET_LAST_ACTIVE_CACHE';
export const SET_ANNOUNCEMENT_CACHE = 'SET_ANNOUNCEMENT_CACHE';
export const GET_ANNOUNCEMENT_CACHE = 'GET_ANNOUNCEMENT_CACHE';

// announcements
export const UPDATE_ANNOUNCEMENT_PRIORITY_FILTER = 'UPDATE_ANNOUNCEMENT_PRIORITY_FILTER';
export const CLEAR_WORKING_ANNOUNCEMENT = 'CLEAR_WORKING_ANNOUNCEMENT';
export const SET_WORKING_ANNOUNCEMENT = 'SET_WORKING_ANNOUNCEMENT';
export const PUBLISH_ANNOUNCEMENT = 'PUBLISH_ANNOUNCEMENT';
export const SAVE_DRAFT_ANNOUNCEMENT = 'SAVE_DRAFT_ANNOUNCEMENT';
export const UPDATE_ANNOUNCEMENT_TYPE = 'UPDATE_ANNOUNCEMENT_TYPE';
export const UPDATE_ANNOUNCEMENT_TITLE = 'UPDATE_ANNOUNCEMENT_TITLE';
export const UPDATE_ANNOUNCEMENT_BODY = 'UPDATE_ANNOUNCEMENT_BODY';
export const START_ANNOUNCEMENT_PUBLISH = 'START_ANNOUNCEMENT_PUBLISH';
export const END_ANNOUNCEMENT_PUBLISH = 'END_ANNOUNCEMENT_PUBLISH';
export const DELETE_DRAFT_ANNOUNCEMENT = 'DELETE_DRAFT_ANNOUNCEMENT';
export const SEARCH_ANNOUNCEMENT = 'SEARCH_ANNOUNCEMENT';
export const SEARCH_TOGGLE = 'SEARCH_TOGGLE';
export const UPDATE_ANNOUNCEMENT_PRIORITY = 'UPDATE_ANNOUNCEMENT_PRIORITY';
export const UPDATE_ANNOUNCEMENT_IMAGE = 'UPDATE_ANNOUNCEMENT_IMAGE';
export const UPDATE_ANNOUNCEMENT_ACKNOWLEDGMENT_REQUIRED = 'UPDATE_ANNOUNCEMENT_ACKNOWLEDGMENT_REQUIRED';
export const ACKNOWLEDGE_ANNOUNCEMENT = 'ACKNOWLEDGE_ANNOUNCEMENT';
export const ASSIGN_PERCENT_ACKNOWLEDGED = 'ASSIGN_PERCENT_ACKNOWLEDGED';
export const GOTO_MENU_ITEM = 'GOTO_MENU_ITEM';
export const LOADING_DRAFT_TOGGLE = 'LOADING_DRAFT_TOGGLE';
export const REMOVE_IMAGE_FILE = 'REMOVE_IMAGE_FILE';
export const SET_PUBLISH_ANNOUNCEMENT_LOADER = 'SET_PUBLISH_ANNOUNCEMENT_LOADER';

// map
export const HIDE_MAP_DETAIL = 'HIDE_MAP_DETAIL';
export const REQUEST_MAPBOX_TOKEN = 'REQUEST_MAPBOX_TOKEN';
export const MAP_POINT_SELECTED = 'MAP_POINT_SELECTED';
export const SET_GRID_PAGE_NUMBER = 'SET_GRID_PAGE_NUMBER';
export const SET_MAPBOX_TOKEN = 'SET_MAPBOX_TOKEN';
export const SHOW_MAP_DETAIL = 'SHOW_MAP_DETAIL';
export const SET_TOTAL_MAP_RECORDS = 'SET_TOTAL_MAP_RECORDS';
export const UPDATE_MAP_VIEW = 'UPDATE_MAP_VIEW';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_SELECTED_LOCATIONS = 'UPDATE_SELECTED_LOCATIONS';

// messages
export const UPDATE_SELECTED_RECIPIENTS = 'UPDATE_SELECTED_RECIPIENTS';
export const ADD_MESSAGE_SECTION = 'ADD_MESSAGE_SECTION';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_MESSAGE_SEARCH_TEXT = 'UPDATE_MESSAGE_SEARCH_TEXT';
export const SET_CONVERSATION_VIEWED = 'SET_CONVERSATION_VIEWED';
export const SET_FORWARD_DATA = 'SET_FORWARD_DATA';
export const DELETE_MESSAGE_ID = 'DELETE_MESSAGE_ID';
export const DELETE_THREAD_ID = 'DELETE_THREAD_ID';
export const RESEND_MESSAGE_ID = 'RESEND_MESSAGE_ID';

// form
export const SET_FORM_EDIT_MODE = 'SET_FORM_EDIT_MODE';
export const SET_FORM_IS_SUBMITTING = 'SET_FORM_IS_SUBMITTING';
export const SET_FORM_INPUT_ERRORS = 'SET_FORM_INPUT_ERRORS';
export const SET_FORM_VALIDATED_STATUS = 'SET_FORM_VALIDATED_STATUS';

export const SET_IS_LOADING = 'SET_IS_LOADING';
export const UNSET_IS_LOADING = 'UNSET_IS_LOADING';

// mPlanReissueForm
export const SET_REISSUE_CONFIRM_CANCEL = 'SET_REISSUE_CONFIRM_CANCEL';
export const SET_REISSUE_CONFIRM_CANCEL_DATA = 'SET_REISSUE_CONFIRM_CANCEL_DATA';
export const SET_REISSUE_INCLUDE_RESPONSES_PREFERENCE = 'SET_REISSUE_INCLUDE_RESPONSES_PREFERENCE';
export const SET_REISSUE_FORM_CLOSE = 'SET_REISSUE_FORM_CLOSE';
export const SET_REISSUE_FORM_OPEN = 'SET_REISSUE_FORM_OPEN';
export const SET_REISSUE_REP_DATA = 'SET_REISSUE_REP_DATA';
export const SET_REISSUED_MPLAN_DATA_TO_UPDATE = 'SET_REISSUED_MPLAN_DATA_TO_UPDATE';
export const REQUEST_CANCEL_REISSUE_MPLAN = 'REQUEST_CANCEL_REISSUE_MPLAN';
export const REQUEST_REISSUE_MPLAN = 'REQUEST_REISSUE_MPLAN';
export const REQUEST_REISSUE_REP_DATA = 'REQUEST_REISSUE_REP_DATA';
export const REQUEST_REISSUE_WINDOW_OPTIONS = 'REQUEST_REISSUE_WINDOW_OPTIONS';

export const GET_VISIT_CAN_REISSUE_CONDITION = 'GET_VISIT_CAN_REISSUE_CONDITION';
export const SET_VISIT_CAN_REISSUE_CONDITION = 'SET_VISIT_CAN_REISSUE_CONDITION';

// WorkApprovalForm
export const SET_WORK_APPROVAL_FORM_DATA = 'SET_WORK_APPROVAL_FORM_DATA';
export const REQUEST_WORK_APPROVAL = 'REQUEST_WORK_APPROVAL';

// GridView
export const SET_GRID_VIEW_SIDE_CONTENT_EXPAND_STATUS = 'SET_GRID_VIEW_SIDE_CONTENT_EXPAND_STATUS';
export const SET_GRID_VIEW_ACTIVE_SIDE_CONTENT = 'SET_GRID_VIEW_ACTIVE_SIDE_CONTENT';

// Grid Header Menu actionTypes
export const SET_GRID_HEADER_MENU_FILTERS = 'SET_GRID_HEADER_MENU_FILTERS';

// custom field actionTypes
export const LOAD_CUSTOM_FIELD_LISTS = 'LOAD_CUSTOM_FIELD_LISTS';
export const UPDATE_CREATE_CUSTOM_FIELD_NAME = 'UPDATE_CREATE_CUSTOM_FIELD_NAME';
export const CLEAR_CREATE_CUSTOM_FIELD_NAME = 'CLEAR_CREATE_CUSTOM_FIELD_NAME';
export const SET_CREATE_CUSTOM_FIELD_ERROR_MESSAGE = 'SET_CREATE_CUSTOM_FIELD_ERROR_MESSAGE';
export const CLEAR_CREATE_CUSTOM_FIELD_ERROR_MESSAGE = 'CLEAR_CREATE_CUSTOM_FIELD_ERROR_MESSAGE';
export const SET_CUSTOM_FIELD_LISTS = 'SET_CUSTOM_FIELD_LISTS';

// Grid Options actionTypes
export const SET_GRID_VIEW_OPTIONS = 'SET_GRID_VIEW_OPTIONS';
export const CLEAR_GRID_VIEW_OPTIONS = 'CLEAR_GRID_VIEW_OPTIONS';

// Cache by Key actionTypes
export const SET_CACHE_BY_KEY = 'SET_CACHE_BY_KEY';
export const GET_CACHE_BY_KEY = 'GET_CACHE_BY_KEY';
export const CLEAR_CACHE_BY_KEY = 'CLEAR_CACHE_BY_KEY';

// assignments actionTypes
export const SET_ASSIGNMENTS = 'SET_ASSIGNMENTS';
export const UPDATE_SELECTED_ASSIGNMENTS = 'UPDATE_SELECTED_ASSIGNMENTS';
export const SET_ASSIGNMENTS_LOCATIONS_COUNT = 'SET_ASSIGNMENTS_LOCATIONS_COUNT';
export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS';
export const CHECK_ASSIGNMENTS_NODE_OPTIONS = 'CHECK_ASSIGNMENTS_NODE_OPTIONS';
export const EXPAND_ASSIGNMENTS_NODE_OPTIONS = 'EXPAND_ASSIGNMENTS_NODE_OPTIONS';
export const UPDATE_ASSIGNMENTS_NODE_OPTIONS = 'UPDATE_ASSIGNMENTS_NODE_OPTIONS';
export const CHECK_MULTIPLE_ASSIGNMENTS_NODES = 'CHECK_MULTIPLE_ASSIGNMENTS_NODES';

export const CANCEL_ASSIGNMENTS_CHANGES = 'CANCEL_ASSIGNMENTS_CHANGES';
export const SAVE_ASSIGNMENTS_CHANGES = 'SAVE_ASSIGNMENTS_CHANGES';
export const SET_ASSIGNMENTS_IS_SAVING_STATUS = 'SET_ASSIGNMENTS_IS_SAVING_STATUS';
export const SET_ASSIGNMENTS_IS_QUICK_SELECT = 'SET_ASSIGNMENTS_IS_QUICK_SELECT';
export const GET_ASSIGNMENTS_QUICK_SELECT_RETAILERS = 'GET_ASSIGNMENTS_QUICK_SELECT_RETAILERS';
export const SET_ASSIGNMENTS_QUICK_SELECT_RETAILERS = 'SET_ASSIGNMENTS_QUICK_SELECT_RETAILERS';
export const SET_ASSIGNMENTS_QUICK_SELECT_RETAILER_SELECTED = 'SET_ASSIGNMENTS_QUICK_SELECT_RETAILER_SELECTED';
export const GET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER = 'GET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER';
export const SET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER = 'SET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER';
export const SET_ASSIGNMENTS_QUICK_SELECT_LOCATION_NUMBERS_INPUT = 'SET_ASSIGNMENTS_QUICK_SELECT_LOCATION_NUMBERS_INPUT';
export const SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST = 'SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST';
export const SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_LIST_NAME = 'SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_LIST_NAME';
export const SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST_ERROR = 'SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST_ERROR';
export const CLEAR_ASSIGNMENTS_QUICK_SELECT_SELECTIONS = 'CLEAR_ASSIGNMENTS_QUICK_SELECT_SELECTIONS';
export const SAVE_ASSIGNMENTS_QUICK_SELECT_UPLOAD_CSV = 'SAVE_ASSIGNMENTS_QUICK_SELECT_UPLOAD_CSV';
export const SAVE_ASSIGNMENTS_QUICK_SELECT_MANUAL_ENTRY = 'SAVE_ASSIGNMENTS_QUICK_SELECT_MANUAL_ENTRY';
export const DOWNLOAD_ASSIGNMENTS_QUICK_SELECT_UPLOAD_TEMPLATE = 'DOWNLOAD_ASSIGNMENTS_QUICK_SELECT_UPLOAD_TEMPLATE';
export const SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_SAVE_AS_LIST = 'SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_SAVE_AS_LIST';
export const SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_LIST_NAME = 'SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_LIST_NAME';
export const SET_ASSIGNMENTS_QUICK_SELECT_UPLOADED_LIST_ID = 'SET_ASSIGNMENTS_QUICK_SELECT_UPLOADED_LIST_ID';
export const SAVE_ASSIGNMENTS_QUICK_SELECT = 'SAVE_ASSIGNMENTS_QUICK_SELECT';
export const GET_ASSIGNMENTS_LOCATIONS_COUNT = 'GET_ASSIGNMENTS_LOCATIONS_COUNT';
export const SET_ASSIGNMENTS_VISIT_DETAILS_CSV_MODAL_OPEN = 'SET_ASSIGNMENTS_VISIT_DETAILS_CSV_MODAL_OPEN';
export const SAVE_ASSIGNMENTS_VISIT_DETAILS_CSV = 'SAVE_ASSIGNMENTS_VISIT_DETAILS_CSV';
export const DOWNLOAD_TEMPLATE_VISIT_DETAILS_CSV = 'DOWNLOAD_TEMPLATE_VISIT_DETAILS_CSV';
export const GET_ASSIGNMENTS_VISIT_DETAILS_CSV = 'GET_ASSIGNMENTS_VISIT_DETAILS_CSV';
export const SET_ASSIGNMENTS_VISIT_DETAILS_CSV = 'SET_ASSIGNMENTS_VISIT_DETAILS_CSV';
export const REMOVE_ASSIGNMENTS_VISIT_DETAILS_CSV = 'REMOVE_ASSIGNMENTS_VISIT_DETAILS_CSV';
export const EXPORT_ASSIGNMENTS_FOR_SCHEDULING_TEMPLATE = 'EXPORT_ASSIGNMENTS_FOR_SCHEDULING_TEMPLATE';
export const SET_ASSIGNMENTS_HAS_RETAILER_OR_CUSTOM_FIELD_SELECTED = 'SET_ASSIGNMENTS_HAS_RETAILER_OR_CUSTOM_FIELD_SELECTED';

// page footer action types
export const GET_PAGEFOOTER_INFO = 'GET_PAGEFOOTER_INFO';
export const SET_PAGEFOOTER_INFO = 'SET_PAGEFOOTER_INFO';
